import { memo } from 'react';

import { customizeStore } from '@/stores';

const Index = () => {
  const { custom_sidebar_bottom } = customizeStore((state) => state);
  if (!custom_sidebar_bottom) return null;
  return <div dangerouslySetInnerHTML={{ __html: custom_sidebar_bottom }} />;
};

export default memo(Index);
